export enum EnumEstadoDictaminacion {
    CargandoInformacion = 0,
    DatosGenerales = 1,
    ConfirmaCorreo = 2,
    DictamenNotificado = 3,
    DictamenNoNotificado = 4,
    CorreoRechazoDictamen = 5
}


export enum EnumAccionDictamen {
    Aceptar = 1,
    Rechazar = 2,
    NotificarAlta = 3,
    NotificarRechazo = 4,
    AltaExito = 5,
    RechazoExito = 6
}